import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth, API } from "../App";
import { Button } from "../components/ui/button";
import { Building2, LayoutDashboard } from "lucide-react";

const DashboardPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (user?.role !== "super_admin") { navigate("/"); return; }
    axios.get(`${API}/super-admin/dashboard`).then((r) => setStats(r.data)).catch(() => {});
  }, [user?.role, navigate]);

  return (
    <div className="min-h-screen bg-stone-50" data-testid="dashboard-page">
      <header className="sticky top-0 z-40 bg-stone-50/80 backdrop-blur-xl border-b border-stone-200">
        <div className="px-4 py-4 flex items-center justify-between">
          <h1 className="font-outfit text-xl font-bold text-stone-900 tracking-tight flex items-center gap-2">
            <LayoutDashboard className="w-5 h-5 text-amber-500" /> Dashboard
          </h1>
          <Button variant="outline" size="sm" onClick={() => navigate("/hotels")} className="rounded-full text-xs" data-testid="dashboard-hotels-button">
            <Building2 className="w-3.5 h-3.5 mr-1.5" /> Gestione Hotel
          </Button>
        </div>
      </header>

      <main className="p-4">
        {!stats ? (
          <p className="text-stone-400 text-sm text-center py-12">Caricamento...</p>
        ) : (
          <>
            <div className="grid grid-cols-3 gap-3 mb-4" data-testid="super-admin-dashboard">
              <div className="bg-white rounded-xl border border-stone-200 p-3 text-center">
                <p className="text-2xl font-bold text-stone-900" data-testid="dashboard-hotel-count">{stats.total_hotels}</p>
                <p className="text-xs text-stone-500">Hotel</p>
              </div>
              <div className="bg-white rounded-xl border border-stone-200 p-3 text-center">
                <p className="text-2xl font-bold text-stone-900" data-testid="dashboard-active-user-count">{stats.active_users || 0}</p>
                <p className="text-xs text-stone-500">Utenti attivi</p>
              </div>
              <div className="bg-white rounded-xl border border-stone-200 p-3 text-center">
                <p className="text-2xl font-bold text-stone-900" data-testid="dashboard-total-task-count">{stats.total_tasks}</p>
                <p className="text-xs text-stone-500">Compiti totali</p>
              </div>
              <div className="bg-white rounded-xl border border-amber-200 p-3 text-center bg-amber-50/30">
                <p className="text-2xl font-bold text-amber-700" data-testid="dashboard-open-task-count">{stats.open_tasks}</p>
                <p className="text-xs text-stone-500">Aperti</p>
              </div>
              <div className="bg-white rounded-xl border border-emerald-200 p-3 text-center bg-emerald-50/30">
                <p className="text-2xl font-bold text-emerald-700" data-testid="dashboard-closed-task-count">{stats.closed_tasks}</p>
                <p className="text-xs text-stone-500">Chiusi</p>
              </div>
              <div className="bg-white rounded-xl border border-stone-200 p-3 text-center">
                <p className="text-2xl font-bold text-stone-900" data-testid="dashboard-user-count">{stats.total_users}</p>
                <p className="text-xs text-stone-500">Utenti totali</p>
              </div>
            </div>

            {stats.hotel_stats?.length > 0 && (
              <div className="space-y-2">
                {stats.hotel_stats.map((h) => (
                  <div key={h.slug} className="bg-white rounded-xl border border-stone-200 p-3 flex items-center gap-3" data-testid={`dashboard-hotel-${h.slug}`}>
                    <Building2 className="w-5 h-5 text-stone-400 flex-shrink-0" />
                    <div className="flex-1 min-w-0">
                      <p className="font-semibold text-stone-900 text-sm truncate">{h.name}</p>
                      <p className="text-xs text-stone-400">
                        {h.users} utenti · {h.channels} canali · {h.tasks} compiti ({h.closed_tasks} chiusi)
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </main>
    </div>
  );
};

export default DashboardPage;
